import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Permission } from '../interfaces/permission';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[hasPermission]',
  standalone: true
})
export class HasPermissionDirective {
  @Input('hasPermission') permission!: Permission;
  private subscription?: Subscription;

  constructor(
    private readonly authService: AuthService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly templateRef: TemplateRef<any>
  ) {}

  ngOnInit(): void {
    this.subscription = this.authService.hasPermissions$(this.permission).subscribe((hasPermission) => {
      this.viewContainerRef.clear();
      if (hasPermission) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
